import { Title } from 'rizzui/typography';
import cn from '@core/utils/class-names';
import Breadcrumb from '@core/ui/breadcrumb';
import { PageTitle } from '@/layouts/hydrogen/page-title';

export type PageHeaderTypes = {
  title: string;
  breadcrumb: { name: string; href?: string }[];
  className?: string;
};

export default function PageHeader({
  title,
  breadcrumb,
  children,
  className,
}: React.PropsWithChildren<PageHeaderTypes>) {
  // Only the title and breadcrumb render in the sticky top header (layouts/hydrogen/page-title.tsx),
  // at the Marketplace admin portal's size (text-xl). Actions never go up there: they stay in the
  // page, right-aligned — and an edit form's own buttons go in its FormFooter, not here (2026-09-28,
  // the project owner's rule). Non-mechanical edit.
  return (
    <>
      <PageTitle>
        <div className="min-w-0">
          <Title
            as="h2"
            className="mb-1 truncate text-xl"
          >
            {title}
          </Title>

          <Breadcrumb
            separator=""
            separatorVariant="circle"
            className="flex-wrap"
          >
            {breadcrumb.map((item) => (
              <Breadcrumb.Item
                key={item.name}
                {...(item?.href && { href: item?.href })}
              >
                {item.name}
              </Breadcrumb.Item>
            ))}
          </Breadcrumb>
        </div>
      </PageTitle>
      {children ? (
        <div className={cn('flex flex-wrap items-center justify-end gap-2', className)}>
          {children}
        </div>
      ) : null}
    </>
  );
}
